export const handleLaunchExternalLink = ({ href }: { href: string }) => {
  const element = document.createElement('a');
  element.href = href;
  element.target = '_blank';
  element.rel = 'noopener noreferrer';
  document.body.appendChild(element);
  element.click();
  element.remove();
};
